import { loginUser } from "../../store/actions";
import { GET_COMPANY_FROM_URL } from "./CommonFunction";
import { runLoginUserBootstrap } from "./ImpersonationFunc";

export const afterloginOneTimeAPI = (user, dispatch) => {
    runLoginUserBootstrap(user, dispatch, { preserveSelectedParty: true });
}


// export const loginFromOutSideLink_Func = ({ Credentials, subPageMode, dispatch, LoginDetails, LoginUserDetails }) => {
//     
//     const [User, password] = Credentials?.split('-');
//     if ((LoginDetails.Status === false) && (Credentials)) {
//         const values = {
//             UserName: User,
//             Password: password
//         }
//         dispatch(loginUser(values))
//     }
//     if (LoginDetails) {
//         dispatch(getUserDetailsAction(LoginDetails.UserID))
//     }
//     if (LoginUserDetails) {
//         dispatch(divisionDropdownSelectAction(localStorage.getItem("EmployeeID")))
//     }


// }




export const loginFromOutSideLink_Func = async ({ Credentials, subPageMode, dispatch, LoginDetails, LoginUserDetails = {}, divisionDropdown }) => {

    const [User, password] = Credentials?.split('-') || [];
    const token = localStorage.getItem(`${GET_COMPANY_FROM_URL()}_token`)

    if ((LoginDetails?.Status === false && Credentials) || !token || !LoginDetails.UserID) {
        const values = {
            UserName: User,
            Password: password
        };
        await dispatch(loginUser(values));
        return
    }

    // if (LoginDetails && LoginDetails.Status === true && !(Object.keys(LoginUserDetails).length > 0)) {
    //     await dispatch(getUserDetailsAction(LoginDetails.UserID));
    //     return
    // }

    // if (LoginUserDetails && !(divisionDropdown.length > 0)) {
    //     const employeeID = localStorage.getItem("EmployeeID");
    //     if (employeeID) {
    //         await dispatch(divisionDropdownSelectAction(employeeID));
    //         return
    //     }
    // }
    // if (divisionDropdown.length > 0) {
    //     const User = divisionDropdown[0]
    //     localStorage.setItem("roleId", JSON.stringify(User));
    //     const Party_Id = User.Party_id
    //     const Employee_Id = User.Employee_id
    //     await dispatch(roleAceessAction(Party_Id, Employee_Id, loginCompanyID()))
    //     await dispatch(getCommonPartyDrodownOptionAction())
    //     await dispatch(getpartysetting_API(Party_Id, loginCompanyID()))
    //     return
    // }


};
